import React from 'react'
import PropTypes from 'prop-types'
import { Button, Slider } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import ProjectCell from '../ProjectCell/ProjectCell'
import styles from './ProjectList.css'

const ProjectList = ({ 
  projects, 
  selectedProjectId, 
  onSelectProject, 
  onOmit, 
  onUnomit, 
  onSearchSubcontractors,
  searchRadius,
  onRadiusChange,
  searchLoading,
  searchResultCount
}) => {
  const projectRefs = React.useRef({})

  React.useEffect(() => {
    if (selectedProjectId && projectRefs.current[selectedProjectId]) {
      projectRefs.current[selectedProjectId].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      })
    }
  }, [selectedProjectId])
  
  if (!projects || projects.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div>No projects to display</div>
        <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>
          Try adjusting your filters
        </div>
      </div>
    )
  }

  return (
    <div className={styles.projectList}>
      {projects.map(project => (
        <div
          key={project.id}
          ref={el => projectRefs.current[project.id] = el}
          className={classNames(styles.projectCard, {
            [styles.selected]: project.id === selectedProjectId
          })}
        >
          <div onClick={() => onSelectProject(project.id)}>
            <ProjectCell 
              record={project}
              onOmit={onOmit}
              onUnomit={onUnomit}
            />
          </div>
          
          {project.id === selectedProjectId && (
            <div className={styles.searchContainer}>
              <div className={styles.radiusControl}>
                <div className={styles.radiusLabel}>Search Radius: {searchRadius} km</div>
                <Slider
                  min={1}
                  max={50}
                  value={searchRadius}
                  onChange={onRadiusChange}
                  marks={{
                    1: '1km',
                    25: '25km',
                    50: '50km'
                  }}
                />
              </div>
              
              <Button
                type="primary"
                icon={<SearchOutlined />}
                block
                loading={searchLoading}
                onClick={(e) => {
                  e.stopPropagation()
                  onSearchSubcontractors(project.id)
                }}
              >
                {searchLoading ? 'Searching...' : 'Search Subcontractors'}
              </Button>
              
              {searchResultCount !== null && !searchLoading && (
                <div className={styles.resultCount}>
                  Found {searchResultCount} subcontractor{searchResultCount !== 1 ? 's' : ''} within {searchRadius}km
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

ProjectList.propTypes = {
  projects: PropTypes.array.isRequired,
  selectedProjectId: PropTypes.number,
  onSelectProject: PropTypes.func.isRequired,
  onOmit: PropTypes.func.isRequired,
  onUnomit: PropTypes.func.isRequired,
  onSearchSubcontractors: PropTypes.func.isRequired,
  searchRadius: PropTypes.number.isRequired,
  onRadiusChange: PropTypes.func.isRequired,
  searchLoading: PropTypes.bool,
  searchResultCount: PropTypes.number,
}

export default ProjectList
